import { connect } from 'react-redux';
import { RootState } from '../reducers/root';
import { SustainabilityImpact } from '../components/SustainabilityPage/SustainabilityImpactPage';

const mapStateToProps = (state: RootState) => ({
  benchmark: state.UserInputState.benchmark,
  BenchmarkFormulasList: state.UserInputState.BenchmarkFormulasList,
  EcoLabel: state.FormulationSpace.SustainabilityData.EcoLabel,
  ImpactData: state.FormulationSpace.SustainabilityData.ImpactData,
  SustainabilityBenchmarkData: state.FormulationSpace.SustainabilityData.SustainabilityBenchmarkData,
  locale: state.AppState.userLocale.locale,
});

export default connect(mapStateToProps)(SustainabilityImpact);
